import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import MainNavigation from "../components/MainNavigation";
import { addToCartAction } from "../store/actions/cartAction";
import { getRestaurantsAction } from "../store/actions/restaurantsAction";
import OfferHeader from "../components/OfferDetails/OfferHeader";
import OfferItemsList from "../components/OfferDetails/OfferItemsList";
import OfferNotesSection from "../components/OfferDetails/OfferNotesSection";
import OfferFooter from "../components/OfferDetails/OfferFooter";

const OfferDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { state } = location;
  const offer = state?.offer;
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const [loader, setLoader] = useState(false);
  const [selectedItemsSize, setSelectedItemsSize] = useState({
    quantity: 1,
    notes: "",
  });
  const totalPrice = offer
    ? Number(offer.price) * selectedItemsSize.quantity
    : 0;
  const { darkMode, color } = useSelector((state) => state.global);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);
  const currency = restaurantsDetail?.currency;

  const handleChange = (e) => {
    setSelectedItemsSize((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const addToCart = (e) => {
    const payload = {
      type: "offer",
      images: offer?.image,
      totalPrice: totalPrice,
      price: Number(offer?.price),
      name: offer?.title,
      cartItems: offer?.items,
      quantity: selectedItemsSize.quantity,
      currency: restaurantsDetail?.currency,
      id: offer?.id,
      restaurantID: offer?.restaurantID,
      notes: selectedItemsSize.notes,
    };
    if (!isMountedRef.current) return;
    setLoader(true);
    dispatch(
      addToCartAction(payload, () => {
        setTimeout(() => {
          if (isMountedRef.current) {
            setLoader(false);
          }
        }, 1000);
        history.goBack();
      })
    );
  };

  useEffect(() => {
    const restaurantID = localStorage.getItem("restaurantId");
    if (!restaurantID && offer?.restaurantID) {
      localStorage.setItem("restaurantId", offer.restaurantID);
    }
    dispatch(getRestaurantsAction(restaurantID || offer?.restaurantID));
  }, [dispatch, offer]);

  return (
    <Container className="product_details">
      <MainNavigation title={""} />
      <Row className="align-items-stretch">
        {" "}
        <Col lg={5} md={5} className="d-flex flex-column">
          {" "}
          <OfferHeader offer={offer} currency={currency} />
        </Col>
        <Col lg={7} md={7} className="px-1 d-flex flex-column">
          <div className="w-100 mb-2">
            <h4
              className={`fw--800 text-center mb-0 ${
                darkMode ? "text-light" : "text-dark"
              }`}
            >
              {offer?.title}
            </h4>
          </div>
          <div className="w-100 flex-grow-1" style={{ overflowY: "auto" }}>
            <h4
              className={`fw-bold mb-3 ${
                darkMode ? "text-light" : "text-dark"
              }`}
            >
              Offer Items
            </h4>
            <OfferItemsList offer={offer} />
            <OfferNotesSection
              darkMode={darkMode}
              selectedItemsSize={selectedItemsSize}
              handleChange={handleChange}
            />
          </div>

          {/* Footer */}
          <div className="w-100">
            <OfferFooter
              darkMode={darkMode}
              color={color}
              totalPrice={totalPrice}
              selectedItemsSize={selectedItemsSize}
              setSelectedItemsSize={setSelectedItemsSize}
              currency={currency}
              loader={loader}
              addToCart={addToCart}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default OfferDetails;
